import { createSlice } from '@reduxjs/toolkit';
import { updateReportClips } from '../../../rtk-apis/reports/updateReportClips';

const initialState = {
  status: '',
  data: null,
  msg: '',
  loading: false,
};

const updateReportClipsSlice = createSlice({
  name: 'updateReportClipsSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateReportClips.pending, state => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(updateReportClips.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'fulfilled';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg || 'Attached clips updated successfully';
      })
      .addCase(updateReportClips.rejected, (state, action) => {
        state.loading = false;
        state.status = 'rejected';
        state.msg = (action?.payload as string) || 'Failed to update attached clips';
      });
  },
});

export const { clearState } = updateReportClipsSlice.actions;
export default updateReportClipsSlice.reducer;
